import installationInstructions from './installationInstructions';

const doorbellCategoryContent = {
  installationInstructions
}

export { doorbellCategoryContent };
